export default __webpack_public_path__ + "static/media/inner.b4600706.svg";